import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { GetThemeModel } from '@data/theme/models';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class ThemeRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverUrl, ApiResources.THEME, true);
  }

  /**
   * Get theme
   */
  getTheme(): Observable<GetThemeModel> {
    return this.customClient.get(ApiResources.THEME).pipe(
      map((item) => {
        if (item) {
          return item.data;
        }

        this.handleResponseRequest(item);
      })
    );
  }
}
